const calcStyle = (...args: (string | number)[]) =>
    `calc(${args.map(a => (typeof a === "number" ? `${a}px` : a)).join(" + ")})`

export default calcStyle
